import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, NamedEntity } from "../../types"
import { NAMED_ENTITY_TYPES, PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<NamedEntity>()

export function TableNamedEntities({
  namedEntities,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  namedEntities: NamedEntity[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!namedEntities) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [namedEntities, count])

  return (
    <Table
      data={namedEntities}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Nome"
        name="name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(entity) => (
          <Link to={`/named-entities/named-entities/${entity.id}`}>
            <LinkMagik className="text-dark">{entity.name}</LinkMagik>
          </Link>
        )}
        stickyLeft
        icon="person"
        // TODO badge
      />
      <Table.Column
        title="Tipo"
        name="entity_type"
        sortable
        width="minmax(max-content, 1fr)"
        render={(entity: NamedEntity) =>
          NAMED_ENTITY_TYPES.find((type) => type.value === entity.type)?.label || entity.type
        }
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} entità
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
